import { getFiatExchangeRates } from '@funkit/api-base'
import { useQuery } from '@tanstack/react-query'

import { logger } from '../../logging/logger'

/**
 * RN port of web's `useFiatExchangeRates`: the fiat exchange-rate table used to
 * convert the host's USD source balance into Swapped's EUR sell cap. Keyless
 * endpoint, cached for an hour (rates barely move within a session).
 */
export function useFiatExchangeRates(enabled = true) {
  const query = useQuery({
    queryKey: ['fiatExchangeRates'],
    queryFn: () => getFiatExchangeRates({ logger }),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    gcTime: 1000 * 60 * 60, // 1 hour
    enabled,
  })

  return query
}
